import apiClient from './client';

export const milestonesAPI = {
  // Получить все вехи проекта
  getByProject: async (projectId) => {
    const response = await apiClient.get(`/milestones/project/${projectId}`);
    return response.data;
  },

  // Получить веху по ID
  getById: async (id) => {
    const response = await apiClient.get(`/milestones/${id}`);
    return response.data;
  },

  // Создать новую веху
  create: async (milestoneData) => {
    // Trailing slash важен для FastAPI
    const response = await apiClient.post('/milestones/', milestoneData);
    return response.data;
  },

  // Обновить веху
  update: async (id, updateData) => {
    const response = await apiClient.put(`/milestones/${id}`, updateData);
    return response.data;
  },

  // Удалить веху
  delete: async (id) => {
    const response = await apiClient.delete(`/milestones/${id}`);
    return response.data;
  },
};
